import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { loadTeamData } from '../utils/teamDataLoader';
import '../styles/components/TeamMembers.scss';

const TeamMembers = () => {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true
    });

    useEffect(() => {
        const fetchTeamMembers = async () => {
            try {
                const response = await fetch('https://api.blackowls.net/discord/getusers');

                if (!response.ok) {
                    throw new Error('API yanıtı başarısız');
                }

                const data = await response.json();
                setMembers(data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchTeamMembers();
    }, []);

    const handleImageError = (e) => {
        // Fallback to placeholder if image fails to load
        e.target.src = '/assets/images/avatar-placeholder.png';
    };

    return (
        <section id="team" className="team-members-section">
            <div className="section-container" ref={ref}>
                <h2 className={`section-title ${inView ? 'fade-in' : ''}`}>
                    {/* KIM */}
                </h2>

                {loading ? (
                    <div className="loading-indicator">Loading team members...</div>
                ) : error ? (
                    <div className="error-message">{error}</div>
                ) : (
                    <div className={`team-content ${inView ? 'slide-up' : ''}`}>
                        <div className="team-grid">
                            {members.map((member, index) => (
                                <div
                                    key={member.id || index}
                                    className="team-member"
                                    style={{
                                        animationDelay: `${index * 0.1}s`,
                                        transform: 'scale(0.95)'
                                    }}
                                >
                                    <div className="member-avatar">
                                        <div className="avatar-frame">
                                            <img
                                                src={`http://api.blackowls.net${member.avatarURL}` || '/assets/images/avatar-placeholder.png'}
                                                alt={member.displayname}
                                                onError={handleImageError}
                                            />
                                        </div>
                                    </div>
                                    <div className="member-info">
                                        <h4 className="member-name">{member.displayname}</h4>
                                        {/* <p className="member-role">{member.role}</p> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default TeamMembers;
